import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useMediaQuery } from 'react-responsive';

import { ACTION, ITEM, SCREEN } from 'shared/modules/auth/constants/mixpanel';
import Button from 'shared/modules/common/components/atoms/Button';
import Dialog from 'shared/modules/common/components/atoms/Dialog';
import Mixpanel from 'shared/vendor/Mixpanel';
import useSignOutUser from 'web/modules/auth/hooks/use-sign-out-user';

type Props = {
  open?: boolean;
  onCancel?: () => void;
};

const Signout = (props: Props) => {
  const isBigScreen = useMediaQuery({ minWidth: 768 });
  const signOutUser = useSignOutUser();

  return (
    <Dialog
      open={props.open}
      title="ログアウトしますか？"
      showCloseButton={false}
      titleAlignment="left"
      style={style.dialog}
      id="signout-dialog"
    >
      <View style={isBigScreen && style.root}>
        <Button
          title="ログアウト"
          onPress={() => {
            Mixpanel.trackEvent(`${SCREEN.LOGOUT} - ${ACTION.CLICK}`, {
              Item: ITEM.YES,
            });

            signOutUser();
          }}
          style={[style.button, isBigScreen && style.buttonBigScreen]}
          id="signout-dialog-signout-button"
        />
        <Button
          title="キャンセル"
          onPress={() => {
            Mixpanel.trackEvent(`${SCREEN.LOGOUT} - ${ACTION.CLICK}`, {
              Item: ITEM.NO,
            });

            props.onCancel?.();
          }}
          variant="outlined"
          style={isBigScreen && style.buttonBigScreen}
          id="signout-dialog-cancel-button"
        />
      </View>
    </Dialog>
  );
};

const style = StyleSheet.create({
  root: {
    flexDirection: 'row',
    marginHorizontal: -8,
  },
  dialog: {
    width: '100%',
    maxWidth: 656,
  },
  button: {
    marginBottom: 16,
  },
  buttonBigScreen: {
    maxWidth: 296,
    marginHorizontal: 8,
    marginBottom: 0,
  },
});

export default Signout;
